export const Keyboard = {
  hide: () => {
    const element = document.activeElement as HTMLInputElement

    if (element) {
      element.blur()
    }
  },
}
